import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_REPORTS_CURRENT_ORDERS,
  GET_REPORTS_CURRENT_ORDERS_SUCCESS,
  GET_REPORTS_CURRENT_ORDERS_FAILED,
  GET_REPORTS_CENTER_ORDERS,
  GET_REPORTS_CENTER_ORDERS_SUCCESS,
  GET_REPORTS_CENTER_ORDERS_FAILED,
} from './constants';

export const initialState: State = {
  reportCurrentOrdersList: {centers: []},
  reportCenterOrdersList: {},
  loading: false,
  error: '',
};

export const ReportsReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_REPORTS_CURRENT_ORDERS:
        draft.loading = true;
        break;
      case GET_REPORTS_CURRENT_ORDERS_SUCCESS:
        draft.reportCurrentOrdersList = action.data;
        draft.loading = false;
        break;
      case GET_REPORTS_CURRENT_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_REPORTS_CENTER_ORDERS:
        draft.loading = true;
        break;
      case GET_REPORTS_CENTER_ORDERS_SUCCESS:
        draft.reportCenterOrdersList = action.data;
        draft.loading = false;
        break;
      case GET_REPORTS_CENTER_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default ReportsReducer;
